import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from '@app/services/app-config.service';
import { HelperService } from '@app/services/helper.service';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, finalize, map, shareReplay } from 'rxjs';
import { ViewQrCodeComponent } from './view-qr-code/view-qr-code.component';
import { SelfService } from '../../services/self.service';

@Component({
    selector: 'app-supplier-details',
    templateUrl: './supplier-details.component.html',
    styleUrl: './supplier-details.component.scss',
    standalone: false
})
export class SupplierDetailsComponent {
  isError = false;
  isMobile = false;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );
  loading: boolean = true;

  supplierId!: number;
  supplierDetail: any = {};

  mode: 'VERIFY' | 'DETAIL' | null = null;
  verifyToken!: string;
  permToken!: string;
  permaLinkUrl!: string;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private route: ActivatedRoute,
    private translocoService: TranslocoService,
    private selfService: SelfService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {

    this.isHandset$.subscribe((r) => {
      console.log("IS HANDSET:", r);
      this.isMobile = r;
    });

    let langData = localStorage.getItem('lang');
    if (langData) {
      this.translocoService.setActiveLang(langData);
    } else {
      this.translocoService.setActiveLang('en');
    }

    this.route.queryParams.subscribe(qp => {
      if (qp) {
        if (qp['verifyToken'] && qp['verifyToken'].length) {
          this.mode = 'VERIFY';
          this.verifyToken = qp['verifyToken'];

          this.selfService.verifySupplier(this.verifyToken).pipe(
            finalize(() =>{
              this.loading = false
            })
          ).subscribe(r => {
            console.log('verifySupplier:', r);
            this.supplierDetail = r.data;
            this.permaLinkUrl = window.location.origin + window.location.pathname + `?permToken=${this.verifyToken}`;

          }, err => {
            console.log('verifySupplier error:', err);
            this.isError = true;
          });

        } else if (qp['permToken'] && qp['permToken'].length) {
          this.mode = 'DETAIL';
          this.permToken = qp['permToken'];

          this.selfService.supplierPublicDetail(this.permToken).pipe(
            finalize(() =>{
              this.loading = false
            })
          ).subscribe(r => {
            console.log('supplierPublicDetail:', r);
            this.supplierDetail = r.data;
            this.permaLinkUrl = window.location.origin + window.location.pathname + `?permToken=${this.permToken}`;

          }, err => {
            console.log('supplierPublicDetail error:', err);
            this.isError = true;
          });
        }
        else{
          this.router.navigateByUrl('/login');
        }
      }
    });

  }

  openQrDialog() {
    const dialogRef = this.dialog.open(ViewQrCodeComponent, {
      width: '500px',
      panelClass: ['tis-details-dialog'],
      data: { qrCodeString: this.permaLinkUrl },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed: ViewQrCodeComponent: ', result);
    });
  }

  changeActiveLanguage(langCode: string) {
    this.translocoService.setActiveLang(langCode);
    localStorage.setItem("lang", langCode);

  }
}
